export const HE_TRANSLATE = {
    "HELLO": "שלום",
    "back": "חזרה",
    "ok": "אישור",
    "cancel": "ביטול",
    "startBtn": "Start",

    "detox": "דיטוקס",
    "detoxPlan": "תפריטים ומתכונים",
    "settings": "הגדרות",
    "shoppingList": "רשימת קניות",
    "termsOfUse": "תנאי שימוש",
    "guides": "מדריכים",
    "aboutUs": "עלינו",
    "slogan": "21 ימים של ניקוי גוף בריא",


    "dailyMenu": "תפריט יומי",
    "day": "יום",

    "finish": "מה עכשיו",
    "ingredients": "מרכיבים",
    "instructions": "אופן ההכנה",
    "intro": "התחלה",
    "markThisDay": "סימון יום זה כבוצע",
    "serving": "מנה",
    "servings": "מנות",
    "meals": [
        {
            "name": "ארוחת בוקר"
        },
        {
            "name": "ארוחת עשר"
        },
        {
            "name": "ארוחת צהריים"
        },
        {
            "name": "ארוחת ביניים"
        },
        {
            "name": "ארוחת ערב"
        }
    ],
    "more": "עוד",
    "language": "שפה",

    "he": "עברית",
    "en": "English",
    "ge": "Deutsch",
    "ru": "русский",
    "fr": "français",
    "sp": "español",
    "po": "português",

    "unit": "יחידת מידה",
    "selectDetoxPlan": "לבחירת סוג תפריט הדיטוקס",
    "detoxPlans": "תוכניות דיטוקס",
    "restart": "איפוס",
    "start": "התחל",
    "days": "ימים",
    "standard": "לאוכלי כל",
    "vegan": "טבעוני",
    "vegetarian": "צמחוני",
    "pescetarian": "צמחוני עם דגים",
    "wellDone":'כל הכבוד!',
    "whatsNow": "מה עכשיו",
    "youDidIt":"כל הכבוד, עשית את זה",
    "weProud":"אנחנו גאים בך,",
    "presentYourself":"נתת לעצמך מתנה מדהימה",


    "messages": {
        "resetApp": {
            "title": "איפוס האפליקציה",
            "content": "פעולה זו תאפס את רשימת הקניות והימים שסימנת שנעשו.\nלחיצה על אישור תאפס את האפליקציה."
        }
    },
}
